import getCouponDiscount from './getCouponDiscount';

export default function getCouponDiscountAmount({ amount = 0, setupFeeAmount = 0, coupon }) {
  if (!coupon) return 0;

  if (amount === 0 && (setupFeeAmount === 0 || !coupon.appliesToSetupFee)) return 0; // prevent coupon discount from being applied on 0 amount, causing negative amounts

  if (setupFeeAmount && coupon.appliesToSetupFee) {
    const amountToBeDiscounted = setupFeeAmount + amount;

    const discountAmount = getCouponDiscount(amountToBeDiscounted, coupon);

    return discountAmount;
  }

  return getCouponDiscount(amount, coupon);
}
